import { Types } from '../actionTypes'

const initialState = {
  lang: 'es',
  enabledInfraRedReader: false,
  enabledMrzWebcam: false,
  scannerStatus: 'disconnected',
}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case Types.SET_LANGUAGE:
      const lang = action.payload
      return { ...state, lang }
    case Types.SET_INFRARED_READER:
      const { enabled } = action.payload
      return {
        ...state,
        enabledInfraRedReader: enabled
      }
    case Types.SET_MRZ_WEBCAM:
      return {
        ...state,
        enabledMrzWebcam: action.payload.enabled
      }
    case Types.SET_SCANNER_STATUS:
      return {
        ...state,
        scannerStatus: action.payload
      }
    default:
      return state
  }
}

export default reducer;